import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import React, { useState } from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { styled } from "@mui/system";
import { CustomTextField } from "../../helpers/helper";
import { toastConfig } from "../../constants/constant";
import CommonDialog from "./CommonDialog";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ResponsiveLoader from "../loader/ResponsiveLoader";
import { Service } from "../../services/service";

const service = new Service();

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "&.MuiDialog-paper": {
    borderRadius: 12,
  },
}));

const AddCustomFieldDialog = ({
  open,
  setOpen,
  title,
  leftButtonText,
  rightButtonText,
  getTranslationsOutputData,
}) => {
  const [loader, setLoader] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [customField, setCustomField] = useState("");

  const userData = useSelector((state) => state?.user);
  const organisationId = userData?.organisationId;
  const transalationId = JSON.parse(localStorage.getItem("transalationId"));

  const areInputsFilled = () => {
    return customField?.trim() !== "";
  };
  const inputFilled = areInputsFilled();

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleCancel = () => {
    if (customField) {
      setConfirmOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleConfirmCancel = () => {
    setOpen(false);
    setConfirmOpen(false);
    setCustomField("");
  };

  const handleSubmit = () => {
    createFeedbackForm();
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setCustomField(value);
  };

  const createFeedbackForm = async () => {
    setLoader(true);
    let url = `/api/Translations/AddCustomOutputField`;
    const user_token = localStorage.getItem("bb_access_token");
    const translationData = prepareTranslationData();
    const formData = JSON.stringify(translationData);
    try {
      let data = await service.newPostApi(url, formData, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        handleConfirmCancel();
        getTranslationsOutputData();
        toast.success(`Custom Field Added Successfully`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const prepareTranslationData = () => {
    return {
      organizationId: organisationId || "",
      translationId: transalationId || 0,
      value: customField || "",
    };
  };

  return (
    <>
      <CustomDialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {loader && <ResponsiveLoader loading={loader} />}
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: "#a50218",
            fontFamily: "Montserrat",
            padding: "32px 32px 12px 32px",
            fontWeight: 500,
            fontSize: "1.75rem",
          }}
        >
          {title || ""}
        </DialogTitle>
        <DialogContent sx={{ minWidth: "600px", padding: "20px 32px" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <label style={labelStyle}>
                Custom Field<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter field here..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="customField"
                value={customField}
                onChange={handleChange}
              />
            </Box>
          </Box>
        </DialogContent>
        <Divider sx={{ height: "0.5px", marginBottom: "20px" }} />
        <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
          <Box>
            <ButtonCta1
              text={leftButtonText}
              variant="contained"
              onClick={handleCancel}
              bgColor="#e0e0e0"
              color="#5a5a5a"
            />
          </Box>
          <Box style={{ marginLeft: "20px" }}>
            <ButtonCta1
              text={rightButtonText}
              disabled={!inputFilled}
              variant="contained"
              onClick={handleSubmit}
              autoFocus
              bgColor="#a50218"
              color="#fff"
            />
          </Box>
        </DialogActions>
      </CustomDialog>
      <CommonDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        handleCancel={handleConfirmClose}
        handleDone={handleConfirmCancel}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default AddCustomFieldDialog;

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};
